export const ROBOT_ROUND_SCHEMA_VERSION = 1;
export const ROBOT_ROUND_STORAGE_PREFIX = 'rbh.beta.robot-round.v1';

export const SEGMENT_TYPES = Object.freeze({
  TRAVEL_CANDIDATE: 'TRAVEL_CANDIDATE',
  STATIONARY_CANDIDATE: 'STATIONARY_CANDIDATE',
  UNCLASSIFIED: 'UNCLASSIFIED',
});

export const REVIEW_TYPES = Object.freeze({
  WORK: 'WERKTIJD',
  TRAVEL: 'REISTIJD',
  UNKNOWN: 'ONBEKEND',
});

export function storageKey(uid) {
  return `${ROBOT_ROUND_STORAGE_PREFIX}.${String(uid || 'anonymous').trim() || 'anonymous'}`;
}
function nowIso() {
  return new Date().toISOString();
}

export function createRobotRoundSession({ ownerUid, ownerName = '', teamMembers = [] } = {}) {
  const startedAt = nowIso();
  return {
    schemaVersion: ROBOT_ROUND_SCHEMA_VERSION,
    id: `round-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`,
    status: 'ACTIVE',
    ownerUid: String(ownerUid || '').trim() || null,
    ownerName: String(ownerName || '').trim(),
    teamMembers: Array.from(new Set((Array.isArray(teamMembers) ? teamMembers : [])
      .map((member) => String(member || '').trim()).filter(Boolean))),
    startedAt,
    stoppedAt: null,
    gpsPermission: 'pending',
    samples: [],
    segments: [],
    events: [],
    feedback: [],
    review: { status: 'DRAFT', proposedEntries: [] },
    instrumentation: {
      samplesCaptured: 0,
      cloudWrites: 0,
      cloudReads: 0,
      functionInvocations: 0,
      myRobotRequests: 0,
      bytesSynced: 0,
    },
  };
}

export function normalizeSession(value) {
  if (!value || typeof value !== 'object') return null;
  if (value.schemaVersion !== ROBOT_ROUND_SCHEMA_VERSION) return null;
  if (!value.id || !value.ownerUid) return null;
  return {
    ...value,
    teamMembers: Array.isArray(value.teamMembers) ? value.teamMembers : [],
    samples: Array.isArray(value.samples) ? value.samples : [],
    segments: Array.isArray(value.segments) ? value.segments : [],
    events: Array.isArray(value.events) ? value.events : [],
    feedback: Array.isArray(value.feedback) ? value.feedback : [],
    review: value.review && typeof value.review === 'object' ? value.review : { status: 'DRAFT', proposedEntries: [] },
    instrumentation: value.instrumentation && typeof value.instrumentation === 'object'
      ? value.instrumentation
      : createRobotRoundSession({ ownerUid: value.ownerUid }).instrumentation,
  };
}

export function isActiveSession(value) {
  return normalizeSession(value)?.status === 'ACTIVE';
}
